var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.5C4 5.67157 4.67157 5 5.5 5H13C13.8284 5 14.5 5.67165 14.5 6.50011V7.99999C14.5 8.27614 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.27602 15.5 7.99987V6.50011C15.5 5.11944 14.3807 4 13 4H5.5C4.11929 4 3 5.11929 3 6.5V17.499C3 18.8797 4.11929 19.999 5.5 19.999H13C14.3807 19.999 15.5 18.8797 15.5 17.499V16C15.5 15.7239 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.7239 14.5 16V17.499C14.5 18.3275 13.8284 18.999 13 18.999H5.5C4.67157 18.999 4 18.3275 4 17.499V6.5ZM9 11.5C8.72386 11.5 8.5 11.7239 8.5 12C8.5 12.2761 8.72386 12.5 9 12.5H19.4129L17.1204 15.1746C16.9407 15.3843 16.9649 15.6999 17.1746 15.8796C17.3843 16.0593 17.6999 16.0351 17.8796 15.8254L20.874 12.3319C20.9095 12.2921 20.9375 12.2477 20.9581 12.2007C20.9846 12.1403 20.9984 12.0761 20.9999 12.0118C21 12.0045 21.0001 11.9972 20.9999 11.9899C20.9996 11.9759 20.9988 11.962 20.9973 11.9481C20.9912 11.8888 20.9747 11.8326 20.9498 11.7813C20.9304 11.7414 20.9055 11.7037 20.8751 11.6693L17.8796 8.17461C17.6999 7.96495 17.3843 7.94067 17.1746 8.12038C16.965 8.30009 16.9407 8.61574 17.1204 8.8254L19.4129 11.5H9Z",
    fill: "currentColor",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.5bd51d33f8bc15ac134043924cbefc47.svg";
export { ForwardRef as ReactComponent };